import {Component, Input, OnInit} from '@angular/core';
import {HttpClient} from '../../../services/http.service';

@Component({
    templateUrl: './wrapper.component.html',
    styleUrls: ['./wrapper.component.scss'],
    standalone: false
})
export class NewsWrapperComponent implements OnInit {

  public newsTotal = null;
  public newsViewsTotal = null;
  public bannerTotal = null;
  public bannerViewsTotal = null;

  constructor(private http: HttpClient) {
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.http.post('News.get_statistic_views')
      .subscribe(
        (response) => {
          this.newsTotal = response.total_news;
          this.newsViewsTotal = response.total_views_news;
          this.bannerTotal = response.total_banner;
          this.bannerViewsTotal = response.total_views_banner;
        },
        (error) => false
      );
  }
}
